export default __webpack_public_path__ + "static/media/comic6_3.0f2bcec9.png";